import { render, staticRenderFns } from "./LinkDistrict.vue?vue&type=template&id=1cf3e6c8&scoped=true&"
import script from "./LinkDistrict.vue?vue&type=script&lang=js&"
export * from "./LinkDistrict.vue?vue&type=script&lang=js&"
import style0 from "./LinkDistrict.vue?vue&type=style&index=0&id=1cf3e6c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf3e6c8",
  null
  
)

export default component.exports